import { ThemeIcon } from '@mantine/core';
import { IconFridge } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { LinkOrigin } from 'src/Services/API/EntityLinks.api';

import styles from './LinkedInventoryItem.module.scss';
import { Props } from './LinkedInventoryItem.types';

const LinkedInventoryItem = ({ item, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container} onClick={onClick}>
      <ThemeIcon variant="light" color="teal" size="lg" radius="md">
        <IconFridge size={18} />
      </ThemeIcon>
      <div className={styles.content}>
        <span className={styles.title}>{item.title}</span>
        {(item.subtitle || Boolean(item.metadata?.exited)) && (
          <span className={styles.subtitle}>
            {[
              item.subtitle,
              item.metadata?.exited ? t('inventory.exited.short', "Sorti de l'inventaire") : null,
            ]
              .filter(Boolean)
              .join(' · ')}
          </span>
        )}
      </div>
      {item.linkOrigin === LinkOrigin.Business && (
        <span className={styles.origin}>
          {t('entityLinks.automaticLink', 'relié automatiquement')}
        </span>
      )}
    </div>
  );
};

export default LinkedInventoryItem;
